import { IStoreIntState } from '../state';
import { IUpdateAbleBreadcrumbAction, IUpdateBreadcrumbAction } from '../actions/update-breadcrumb';

export type UpdateBreadcrumbAction = IUpdateBreadcrumbAction;
export type UpdateAbleBreadcrumbAction = IUpdateAbleBreadcrumbAction;

export const updateBreadcrumbReducer = (state: IStoreIntState,
    action: IUpdateBreadcrumbAction) => {
    let existingBreadcrumbData = [...state.breadcrumbData];
    const currentBreadcrumbItem = (action as IUpdateBreadcrumbAction).currentBreadcrumb;
    const defaultBreadcrumbs = (action as IUpdateBreadcrumbAction).defaultBreadcrumbs;
    if (existingBreadcrumbData.length > 1) {
        const index = existingBreadcrumbData.findIndex((item) => item.link === currentBreadcrumbItem.link);
        existingBreadcrumbData.map((item) => {
            item.active = false;
            return item;
        })
        if (index !== -1) {
            if (index === (existingBreadcrumbData.length - 1)) {
                existingBreadcrumbData[existingBreadcrumbData.length - 1].label = currentBreadcrumbItem.label;
            }
            existingBreadcrumbData.splice(index + 1);
        } else {
            existingBreadcrumbData.push(currentBreadcrumbItem);
        }
    } else {
        if (defaultBreadcrumbs && defaultBreadcrumbs.length) {
            existingBreadcrumbData = defaultBreadcrumbs;
        }
    }
    existingBreadcrumbData[existingBreadcrumbData.length - 1].active = true;
    return ({
        ...state,
        breadcrumbData: existingBreadcrumbData
    });
}

export const updateAbleBreadcrumbReducer = (state: IStoreIntState,
    action: IUpdateAbleBreadcrumbAction) => {
    let existingBreadcrumbData = [...state.ableBreadcrumbData];
    const currentBreadcrumbItem = (action as IUpdateAbleBreadcrumbAction).currentBreadcrumb;
    const defaultBreadcrumbs = (action as IUpdateAbleBreadcrumbAction).defaultBreadcrumbs;
    if (existingBreadcrumbData.length > 1) {
        const index = existingBreadcrumbData.findIndex((item) => item.to === currentBreadcrumbItem.to);
        existingBreadcrumbData.map((item) => {
            item.active = false;
            return item;
        })
        if (index !== -1) {
            if (index === (existingBreadcrumbData.length - 1)) {
                existingBreadcrumbData[existingBreadcrumbData.length - 1].label = currentBreadcrumbItem.label;
            }
            existingBreadcrumbData.splice(index + 1);
        } else {
            existingBreadcrumbData.push(currentBreadcrumbItem);
        }
    } else {
        if (defaultBreadcrumbs && defaultBreadcrumbs.length) {
            existingBreadcrumbData = defaultBreadcrumbs;
        }
    }
    existingBreadcrumbData[existingBreadcrumbData.length - 1].active = true;
    return ({
        ...state,
        ableBreadcrumbData: existingBreadcrumbData
    });
}